const Modal2 = ({ isOpen, closeModal, children }) => {
  if (!isOpen) return null; // Don't render the modal if it's not open

  const handleBackdropClick = (e) => {
    // Close modal when the backdrop (outer div) is clicked
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  return (
    <div
      className="!leap-fixed leap-w-full leap-inset-0 leap-flex leap-items-center leap-justify-center leap-z-50 leap-bg-black leap-bg-opacity-50"
      onClick={handleBackdropClick} // Detect click on the backdrop
    >
      <div
        className="leap-bg-slate-900 leap-h-[90vh] leap-overflow-auto leap-rounded-lg leap-w-full leap-shadow-lg  leap-relative leap-scale-90 lg:leap-scale-75"
        onClick={(e) => e.stopPropagation()} // Prevent closing modal when clicking inside
      >
        {/* <button
          onClick={() => closeModal()}
          className="!leap-absolute leap-top-5 leap-right-6 leap-text-gray-500 leap-hover:text-gray-800 leap-text-4xl"
        >
          &times;
        </button> */}
        <div className="leap-w-full">{children}</div>
        {/* Full width applied to children */}
      </div>
    </div>
  );
};

export default Modal2;
